(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-pu-hardshell-facts]').forEach((slider) => {
    const rail = slider.querySelector('[data-pu-hardshell-facts-rail]');
    const slides = Array.from(slider.querySelectorAll('[data-pu-hardshell-fact-slide]'));
    const prev = slider.querySelector('[data-pu-hardshell-facts-prev]');
    const next = slider.querySelector('[data-pu-hardshell-facts-next]');
    if (!rail || slides.length === 0) return;

    let activeIndex = 0;
    let frame = 0;

    const update = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      if (prev) prev.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    };

    const goTo = (index) => {
      const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (!target) return;
      rail.scrollTo({ left: target.offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      update(index);
    };

    prev?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));
    rail.addEventListener('keydown', (event) => {
      let target = activeIndex;
      if (event.key === 'ArrowRight') target = activeIndex + 1;
      else if (event.key === 'ArrowLeft') target = activeIndex - 1;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = slides.length - 1;
      else return;
      event.preventDefault();
      goTo(target);
    });
    rail.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const railLeft = rail.getBoundingClientRect().left;
        const closest = slides.reduce((best, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - railLeft);
          return distance < best.distance ? { index, distance } : best;
        }, { index: activeIndex, distance: Infinity });
        if (closest.index !== activeIndex) update(closest.index);
      });
    }, { passive: true });
    update(0);
  });
})();
